var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6966 1.28263C12.6966 1.28263 12.6972 1.28313 12.6989 1.28483L12.6978 1.28374L12.7105 1.29508C12.7281 1.31064 12.763 1.34044 12.8171 1.38252C12.9252 1.46665 13.1107 1.60023 13.3895 1.76751C13.9469 2.10195 14.8797 2.57246 16.3162 3.05132C17.7858 3.54118 18.7451 3.77921 19.3211 3.89442C19.6087 3.95194 19.7987 3.97843 19.9073 3.99049C19.9615 3.99651 19.995 3.9989 20.0099 3.99977L20.0166 4.00014C20.5613 4.00902 21 4.45327 21 5V12C21 15.4464 18.7183 18.2003 16.6585 20.0026C15.6076 20.9221 14.5615 21.6408 13.78 22.1292C13.3882 22.3741 13.0603 22.5627 12.8281 22.6913C12.6303 22.8008 12.4417 22.8738 12.2373 22.935C12.0825 22.9814 11.9171 22.983 11.7622 22.9369C11.5576 22.8761 11.3695 22.8007 11.1719 22.6913C10.9397 22.5627 10.6118 22.3741 10.22 22.1292C9.43854 21.6408 8.39238 20.9221 7.3415 20.0026C5.28175 18.2003 3 15.4464 3 12V5C3 4.45328 3.43875 4.00903 3.98335 4.00014L3.99011 3.99977C4.00499 3.9989 4.0385 3.99651 4.09269 3.99049C4.20126 3.97843 4.39127 3.95194 4.67888 3.89442C5.25494 3.77921 6.21419 3.54118 7.68377 3.05132C9.12034 2.57246 10.0531 2.10195 10.6105 1.76751C10.8893 1.60023 11.0748 1.46665 11.1829 1.38252C11.237 1.34044 11.2719 1.31064 11.2896 1.29508L11.3022 1.28374C11.6903 0.905419 12.3097 0.905419 12.6978 1.28374L12.6966 1.28263Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPic);
export default __webpack_public_path__ + "static/media/privacyPic.990a910f8b16c4f30810eab4723210b8.svg";
export { ForwardRef as ReactComponent };